import { ForcedRankingsService } from 'src/services/ForcedRankingsService';

export const createForcedRankingStrategy = async (
    {
        accessToken,
        strategyName,
        body,
        signal,
    }: App.ForcedRankings.CreateMutationVariables,
): Promise<Models.IngestConfigApi.ForcedRankings.ForcedRankingStrategy> => ForcedRankingsService
    .createForcedRankingStrategy(
        accessToken,
        strategyName,
        body,
        signal,
    );
